import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { fetchAllModule, resetModuleData } from "../../slices/moduleSlice";
import { fetchAllTasks, resetTask } from "../../slices/taskSlice";
import CButton from "../../components/CButton";
import AddIcon from "@mui/icons-material/AddOutlined";
import { useNavigate } from "react-router-dom";
import { fetchAllAssignment, resetAssignment } from "../../slices/assignment";
import EditIcon from "@mui/icons-material/EditOutlined";

const AssignmentList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { moduleList } = useSelector((state) => state.module);
  const { taskList } = useSelector((state) => state.task);

  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [totalRowsData, setTotalRowsData] = useState(0);
  const [assignmentData, setAssignmentData] = useState([]);
  const [qusTask, setQusTask] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25,
  });
  const { assignmentList, totalRows } = useSelector(
    (state) => state.assignment
  );

  useEffect(() => {
    const fetchAllAssignmentAPI = () => {
      let payload = {
        page: paginationModel.page + 1,
        limit: paginationModel.pageSize,
        moduleId: selectedModule,
        taskId: selectedTask,
      };
      dispatch(fetchAllAssignment(payload));
    };
    selectedModule && selectedTask && fetchAllAssignmentAPI();
  }, [selectedModule, selectedTask, dispatch, paginationModel]);

  useEffect(() => {
    dispatch(resetAssignment());
  }, [dispatch]);

  useEffect(() => {
    setAssignmentData(assignmentList);
    setTotalRowsData(totalRows);
  }, [assignmentList, totalRows]);

  useEffect(() => {
    dispatch(resetTask());
    dispatch(resetModuleData());
  }, [dispatch]);

  useEffect(() => {
    const QusList = taskList.filter((data) => data.taskType === "Question");
    setQusTask(QusList);
  }, [taskList]);

  useEffect(() => {
    const fetchAllModuleAPI = () => {
      let payload = {
        page: 1,
        limit: -1,
      };
      dispatch(fetchAllModule(payload));
    };
    fetchAllModuleAPI();
  }, [dispatch]);

  const columns = [
    {
      field: "_id",
      headerName: "ID",
      flex: 1.5,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "title",
      headerName: "Assignment Title",
      flex: 2.5,
      disableColumnMenu: true,
    },
    {
      field: "actions",
      headerName: "Action",
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        return (
          <div>
            <CButton
              onClick={() => navigate(`/assignment/${params.row._id}`)}
              className="btn-text"
            >
              <EditIcon />
            </CButton>
          </div>
        );
      },
    },
  ];

  const Placeholder = ({ children }) => {
    return <div>{children}</div>;
  };

  const handlePaginationChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  useEffect(() => {
    if (selectedModule !== null) {
      let payload = {
        page: 1,
        limit: -1,
        moduleId: selectedModule,
      };
      dispatch(fetchAllTasks(payload));
      dispatch(resetAssignment());
    }
  }, [selectedModule, dispatch]);

  return (
    <div className="main-content report-content">
      <div className="company-heading">
        <h2>Assignment</h2>
        <CButton
          onClick={() => navigate("/add-assignment")}
          className="btn-primary"
        >
          <AddIcon /> Add Assignment
        </CButton>
      </div>
      <div className="card-box">
        <div className="report-table-filter">
          <div className="report-table-left"></div>
          <div className="report-table-right">
            <FormControl fullWidth className="CSelect">
              <InputLabel id="demo-simple-select-label">Module</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                label="Module"
                name="module"
                id="demo-simple-select"
                displayEmpty
                renderValue={
                  selectedModule !== null
                    ? undefined
                    : () => <Placeholder>Select Module</Placeholder>
                }
                onChange={(e) => {
                  setSelectedModule(e.target.value);
                  setSelectedTask(null);
                }}
                placeholder="Select"
                value={selectedModule || ""}
                IconComponent={(props) => <ExpandMoreIcon {...props} />}
                inputlabelprops={{ shrink: true }}
              >
                {moduleList?.map((data) => (
                  <MenuItem key={data._id} value={data._id}>
                    {data?.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth className="CSelect">
              <InputLabel id="demo-simple-select-label">Task</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                label="Task"
                name="task"
                id="demo-simple-select"
                displayEmpty
                renderValue={
                  selectedTask !== null
                    ? undefined
                    : () => <Placeholder>Select Task</Placeholder>
                }
                disabled={qusTask.length === 0}
                onChange={(e) => {
                  setSelectedTask(e.target.value);
                  setPaginationModel({
                    page: 0,
                    pageSize: 25,
                  });
                }}
                placeholder="Select"
                value={selectedTask || ""}
                IconComponent={(props) => <ExpandMoreIcon {...props} />}
                inputlabelprops={{ shrink: true }}
              >
                {qusTask?.map((data) => (
                  <MenuItem key={data._id} value={data._id}>
                    {data?.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <Box className="table-box assignment-table">
          <DataGrid
            initialState={{
              columns: {
                columnVisibilityModel: {
                  _id: false,
                },
              },
              pagination: { paginationModel: { pageSize: 25 } },
            }}
            rowCount={totalRowsData || 0}
            columns={columns}
            rows={assignmentData}
            paginationModel={paginationModel}
            paginationMode="server"
            autoHeight={false}
            getRowId={(row) => row._id}
            rowSelection={false}
            onPaginationModelChange={(e) => handlePaginationChange(e)}
            disableColumnFilter
            hover={false}
            localeText={{ noRowsLabel: "No records found" }}
          />
        </Box>
      </div>
    </div>
  );
};

export default AssignmentList;
